/* ==========================================================================
   ZWANZE — favorites.js
   Système de favoris avec cœur. Stockage dans localStorage.
   Le composant z-heart-btn affiche un cœur vide (noir) ou rempli (jaune).
   ========================================================================== */
(function () {
  'use strict';

  const STORAGE_KEY = 'zwanze_favorites';

  class HeartBtn extends HTMLElement {
    connectedCallback() {
      // data-product-id est obligatoire
      const productId = this.dataset.productId;
      if (!productId) return;

      this.productId = productId;
      this.updateState();

      // Au clic, basculer l'état et émettre un événement.
      // stopPropagation : le cœur vit souvent dans une carte entièrement
      // cliquable — sans ça, le clic remonterait et ouvrirait la fiche.
      this.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      });
    }

    toggle() {
      const favorites = this.getFavorites();
      const index = favorites.indexOf(this.productId);

      if (index > -1) {
        favorites.splice(index, 1);
      } else {
        favorites.push(this.productId);
      }

      this.saveFavorites(favorites);
      this.updateState();

      // Émettre un événement personnalisé pour que d'autres composants se mettent à jour
      document.dispatchEvent(new CustomEvent('favorites-changed', {
        detail: { productId: this.productId, isFavorite: index === -1 }
      }));
    }

    updateState() {
      const isFavorite = this.getFavorites().includes(this.productId);
      this.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
      this.classList.toggle('is-liked', isFavorite);
    }

    getFavorites() {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    }

    saveFavorites(favorites) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    }
  }

  if (!customElements.get('z-heart-btn')) {
    customElements.define('z-heart-btn', HeartBtn);
  }

  // Exposer une API globale pour accéder aux favoris
  window.Zwanze = window.Zwanze || {};
  window.Zwanze.Favorites = {
    get: function() {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    },
    set: function(favorites) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
      document.dispatchEvent(new CustomEvent('favorites-changed'));
    },
    toggle: function(productId) {
      const favorites = this.get();
      const index = favorites.indexOf(productId);
      if (index > -1) {
        favorites.splice(index, 1);
      } else {
        favorites.push(productId);
      }
      this.set(favorites);
      return index === -1; // Retourne true si on vient d'ajouter
    },
    isFavorite: function(productId) {
      return this.get().includes(productId);
    }
  };
})();
